// @ts-nocheck
import {
    partNumberStyles,
    ProductDetailsPartNumberStyles,
} from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(partNumberStyles, {
    labelText: {
        size: 16,
        weight: "normal",
        css: css`
            margin-right: ${pxToRem(15)};
        `,
    },
    valueText: {
        css: css`
            padding-bottom: ${pxToRem(10)};
            border-bottom: ${pxToRem(1)} solid ${getColor("text.lighter")};
        `,
    },
} as ProductDetailsPartNumberStyles);
